import $ from 'jquery';
import Popup from '../utilities/Popup';

$('.about-mainscreen-play').click(function () {
    $('.about-mainscreen').addClass('about-mainscreen--opened');
    $('.about-mainscreen-video').show();
    $('.about-mainscreen-video')[0].volume = 0.1;
    $('.about-mainscreen-video')[0].play();
    $('.about-mainscreen__close').show();
    $('.about-mainscreen .wrap').hide();
});

$('.about-mainscreen__close').click(function () {
    $('.about-mainscreen').removeClass('about-mainscreen--opened');
    $('.about-mainscreen-video')[0].pause();
    $('.about-mainscreen-video').hide();
    $('.about-mainscreen__close').hide();
    $('.about-mainscreen .wrap').show();
});

$('.about-media-video__wrap').click(function () {
    const $iframe = $(this).closest('.about-media-video').find('iframe').clone();
    Popup.watch($iframe);
});
